import { HttpLink } from "apollo-link-http";
import config from "../../config";

export const httpLink = new HttpLink({
  uri: config.graphql.nesApi.httpEndpoint
});
